import React from 'react';
import ManageSignatories from '@pages-clean/shared/manage-signatories/manage-signatories';
import Constants from '@utils/constants';

const SubjectMonitoringManageSignatories = () => {
    return <ManageSignatories module={Constants.Modules.SM} />;
};
export default SubjectMonitoringManageSignatories;
